import type { AuditLogsResponse, OwnerAuditLogsRequest, ProjectAuditLogsRequest } from '@/app/pages/AuditLogs/types'
import type { AuditLogsParams, AuditLogsSearchResponse } from '@/types/organization-owner-api'
import { isDemoDeployment } from '@/utils/deployment'
import { apiCall, ownerApiCall } from './axiosInstance'
import { auditLogsApi as demoAuditLogsApi } from './demo/auditLogsApi'

const v3AuditLogsApi = {
	/**
	 * Get owner-wide audit logs (for root tenant)
	 * No x-bytebeam-tenant header required (instance owner access)
	 */
	getOrganizationAuditLogs: async (
		organizationId: string,
		params: AuditLogsParams | OwnerAuditLogsRequest,
	): Promise<AuditLogsSearchResponse & { data: AuditLogsResponse['data'] }> => {
		return ownerApiCall<AuditLogsSearchResponse & { data: AuditLogsResponse['data'] }>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/audit-logs`,
			{ method: 'POST', data: params },
		)
	},

	/**
	 * Get project (tenant) audit logs (for non-root tenants)
	 * Includes x-bytebeam-tenant header (via default axios instance)
	 */
	getProjectAuditLogs: async (params: ProjectAuditLogsRequest): Promise<AuditLogsResponse> =>
		apiCall<AuditLogsResponse>('/v3/project-audit-logs', {
			method: 'POST',
			data: params,
		}),
}

export const auditLogsApi = isDemoDeployment() ? demoAuditLogsApi : v3AuditLogsApi
